import { EyeOff } from "lucide-react";
import { media } from "@/lib/api";

export const Cover = ({ src, hidden, className = "", spin = false, testid }) => {
  if (hidden || !src) {
    return (
      <div data-testid={testid} className={`blind-cover relative flex items-center justify-center overflow-hidden ${className}`}>
        {hidden ? <EyeOff className="h-1/3 w-1/3 text-[#FF2E63]/80" /> : <div className="vinyl h-3/4 w-3/4 rounded-full" />}
      </div>
    );
  }
  return (
    <div data-testid={testid} className={`relative overflow-hidden ${className}`}>
      <img src={media(src)} alt="" className={`h-full w-full object-cover ${spin ? "spin-slow" : ""}`} />
    </div>
  );
};

const BADGE_STYLE = {
  "Founding Artist": "border-[#FFB800]/60 text-[#FFB800]",
  "Blind #1": "border-[#FF2E63]/70 text-[#FF2E63]",
  "Fan Favourite": "border-[#FF2E63]/70 text-[#FF2E63]",
  Pro: "border-[#00F5D4]/60 text-[#00F5D4]",
};

export const Badges = ({ badges = [], plan, className = "" }) => {
  const list = [...new Set([...(badges || []), ...(plan === "pro" ? ["Pro"] : [])])];
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {list.map((b) => (
        <span key={b} data-testid={`badge-${b.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest ${BADGE_STYLE[b] || "border-white/20 text-slate-300"}`}>
          {b}
        </span>
      ))}
    </div>
  );
};

export const SectionHead = ({ label, title, children, className = "" }) => (
  <div className={`mb-8 ${className}`} data-reveal>
    <div className="label-mono mb-3">{label}</div>
    <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl">{title}</h2>
    {children && <p className="mt-3 max-w-2xl text-slate-400">{children}</p>}
  </div>
);
